import { COLORS, marginMd, marginSm, paddingMd } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';
import CustomSelect from 'components/Select/FormikSelect';
import styled, { css } from 'styled-components';

interface StyledProps {
  isSelected: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-self: center;
  padding: 30rem;
  width: 100%;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Title = styled.div`
  font-size: 24px;
  font-weight: 300;
  line-height: 36px;
  letter-spacing: 0em;
  text-align: left;
  color: ${COLORS.BLACK};
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${paddingMd};
  max-height: 859rem;
`;

export const Label = styled.div`
  max-width: 300rem;
  color: ${COLORS.BLACK};
`;

export const HorizontalLine = styled.div`
  width: 635rem;
  height: 1rem;
  background-color: ${COLORS.GRAY_300};
`;

export const ApplyWrapper = styled.div`
  display: flex;
  padding-top: 32rem;
  align-items: center;
  justify-content: center;
  gap: 30rem;

  ${respondTo.smallPhone`
    flex-direction: column;
    gap: 10rem;
  `}
`;
export const ColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
  gap: 10rem;
`;

export const RowSpaceBetween = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 30rem;

  ${respondTo.smallTablet`
  flex-direction: column;
  gap: 15rem;
  `}
`;

export const RowSpaceBetweenAlignCenter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: 40rem;
`;

export const StyledFormikSelect = styled(CustomSelect)`
  width: 300rem;
`;

export const Row = styled.div`
  display: flex;
  margin-top: 14rem;
`;

export const FilterTypesWrapper = styled.div`
  display: flex;
  height: 30rem;
  margin-top: ${marginMd};
`;

export const FilterTypeLabel = styled.label`
  cursor: pointer;
  font-weight: 300;
  font-size: 18rem;
  line-height: 27rem;
  margin-right: ${marginMd};
  color: ${COLORS.BLACK};
  ${(props: StyledProps) =>
    props.isSelected &&
    css`
      color: ${COLORS.GREEN};
      text-decoration: underline;
      text-decoration-thickness: 2rem;
      text-decoration-position: under;
    `}
`;

export const CheckBoxWrapper = styled.div`
  margin-top: 30rem;
`;

export const FixedRatesSection = styled.div`
  margin-top: 20rem;
`;

export const FixedRatesHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10rem;
`;

export const FixedRatesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8rem;
  border: 1px solid ${COLORS.GRAY_300};
  border-radius: 8rem;
  overflow: hidden;
`;

export const FixedRateItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8rem 12rem;
  background-color: ${COLORS.GRAY_100};
  border-radius: 4rem;
`;

export const FixedRateKey = styled.span`
  font-weight: 500;
  color: ${COLORS.BLACK};
`;

export const FixedRateValue = styled.span`
  color: ${COLORS.BLACK};
`;

export const EmptyRatesText = styled.p`
  color: ${COLORS.GRAY_300};
  font-style: italic;
  margin: 0;
`;
